import React, { useState } from 'react';
import { useScreenDetector } from "../../hooks/useScreenDetector.ts";
import { Address } from "../../types/Delivery.interface.ts";
import { DesktopCartPage } from "./pages/DesktopCartPage/DesktopCartPage.tsx";
import { MobileCartPage } from "./pages/MobileCartPage/MobileCartPage.tsx";
import { PickupPointModal } from "../../widgets/Delivery/components/PickupPointModal/PickupPointModal.tsx";
import { ChooseCityModal } from "../../widgets/Geolocation/Components/ChooseCityModal/ChooseCityModal.tsx";
// import { useMultiStorage } from '../../hooks/useStorage.ts';
import { API_URL } from '../../config.tsx';
import { RootState, useAppDispatch, useAppSelector } from '@/utils/storage/stores/store.ts';
import { cartOfferLoader } from '@/utils/storage/extra/loaders/cart/cartOfferLoader.ts';
import { CartPageLoader } from './CartPageLoader.tsx';

type ProductOperation = 'add' | 'remove'

export const CartPage: React.FC = () => {
    const dispatch = useAppDispatch();
    const cartId = useAppSelector((state: RootState) => state.user.userInfo?.cartId as number);
    const cartOffer = useAppSelector((state: RootState) => state.cart.cartOffer);
    const { isDesktop } = useScreenDetector();
    const [controllers, setControllers] = useState([]);
    const [isBranchShown, setIsBranchShown] = useState(false)
    const [isOpenChangeTownModal, setIsOpenChangeTownModal] = useState(false);
    const username = useAppSelector((state: RootState) => state.user.userInfo?.username || null);

    // const [loading, setLoading] = useState<boolean>(false);
    // const [storage, setStorage] = useMultiStorage({
    // getCartOffer: ['getCartOffer', false],
    // });

    const handleAbort = () => {
        controllers.map(controller => {
            // @ts-ignore
            controller.abort();
        })
    }

    const onPaymentMethodChange = (variant: string) => {
        fetch(`${API_URL}/cart/${cartId}/change_payment_variant`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ variant }),
        });
    };

    const onDeliveryTypeChange = (type: string) => {
        fetch(`${API_URL}/cart/${cartId}/change_delivery_type`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ type }),
        })
            .then(() => onProductChange());
    };

    const onDeliveryAddressChange = (address: Address) => {
        handleAbort();
        let newControllersList = controllers;
        const abortController = new AbortController();
        // @ts-ignore
        newControllersList.push(abortController);
        setControllers(newControllersList);
        fetch(`${API_URL}/cart/${cartId}/change_delivery_address`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ address: address }),
            signal: abortController.signal
        })
            .then(response => response.json())
            .then(() => onProductChange());
    };

    const onDeliveryTransportCompanyChange = (transportCompanyId: number) => {
        fetch(`${API_URL}/cart/${cartId}/change_delivery_transport_company`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ transportCompanyId }),
        })
            .then(() => onProductChange());
    };

    const createOrder = (withBonuses: boolean) =>
        fetch(`${API_URL}/cart/${cartId}/create_order`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                withBonuses,
            }),
        });

    const addOrLessenProduct = (elementId: number, operation: ProductOperation) => {
        fetch(`${API_URL}/cart_element/${elementId}/change_amount`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ operation }),
        })
            .then(() => onProductChange())
    }

    const removeProducts = (ids: number[]) => {
        ids.map((id: number) => {
            fetch(`${API_URL}/cart_element/${id}/remove`, {
                method: 'DELETE',
            })
                .then(() => onProductChange())
                .then(() => dispatch(cartOfferLoader({ cartId: cartId || 0, isMini: true })));
        });
    }

    const onProductChange = () => {
        dispatch(cartOfferLoader({ cartId: cartId || 0, isMini: false }));
    };

    return (
        <CartPageLoader>
            {
                isBranchShown && cartOffer
                    ? <PickupPointModal
                        isOpen={true}
                        close={() => setIsBranchShown(false)}
                        open={() => setIsBranchShown(true)}
                        currentBranchAddress={cartOffer.delivery.point.address}
                        currentBranchId={cartOffer.delivery.branchId}
                        currentTownId={cartOffer.delivery.townId}
                        forCart={true}
                    />
                    : null
            }
            {
                isOpenChangeTownModal
                    ? <ChooseCityModal
                        isOpen={true}
                        close={() => setIsOpenChangeTownModal(false)}
                    />
                    : null
            }
            {
                isDesktop
                    ? <DesktopCartPage
                        cartOffer={cartOffer}
                        isAuth={username !== null}
                        onPaymentMethodChange={onPaymentMethodChange}
                        onDeliveryTypeChange={onDeliveryTypeChange}
                        onDeliveryAddressChange={onDeliveryAddressChange}
                        onDeliveryTransportCompanyChange={onDeliveryTransportCompanyChange}
                        createOrder={createOrder}
                        addOrLessenProduct={addOrLessenProduct}
                        removeProducts={removeProducts}
                        setIsBranchShown={setIsBranchShown}
                        setIsOpenChangeTownModal={setIsOpenChangeTownModal}
                    />
                    : <MobileCartPage
                        cartOffer={cartOffer}
                        onPaymentMethodChange={onPaymentMethodChange}
                        onDeliveryTypeChange={onDeliveryTypeChange}
                        onDeliveryTransportCompanyChange={onDeliveryTransportCompanyChange}
                        createOrder={createOrder}
                        addOrLessenProduct={addOrLessenProduct}
                        removeProducts={removeProducts}
                        setIsOpenChangeTownModal={setIsOpenChangeTownModal}
                        isAuth={username !== null}
                        onDeliveryAddressChange={onDeliveryAddressChange}
                    />
            }
        </CartPageLoader>
    );
};
